import http from './http';
import {GROUP_BASE} from './paths';
import {withPerm} from './perm';

const BASE_URL = GROUP_BASE;

// 목록 (전체 또는 타입 필터)
export const getGroups = withPerm(async (groupType) => {
  const url = groupType ? `${BASE_URL}?groupType=${groupType}` : BASE_URL;
  const res = await http.get(url);
  return res.data; // {code, message, data} 또는 배열
}, 'GET', `${BASE_URL}`);

// 단건
export const getGroup = withPerm(async (groupId) => {
  const res = await http.get(`${BASE_URL}/${groupId}`);
  return res.data;
}, 'GET', `${BASE_URL}/{groupId}`);

// 생성
export const createGroup = withPerm(async (payload) => {
  const res = await http.post(BASE_URL, payload, { headers: { 'Content-Type': 'application/json' } });
  return res.data;
}, 'POST', `${BASE_URL}`);

// 기본정보 수정
export const updateGroup = withPerm(async (groupId, payload) => {
  const res = await http.put(`${BASE_URL}/${groupId}`, payload, { headers: { 'Content-Type': 'application/json' } });
  return res.data;
}, 'PUT', `${BASE_URL}/{groupId}`);

// 단건 삭제
export const deleteGroup = withPerm(async (groupId) => {
  const res = await http.delete(`${BASE_URL}/${groupId}`);
  return res.data;
}, 'DELETE', `${BASE_URL}/{groupId}`);

// 일괄 삭제
export const deleteGroupBatch = withPerm(async (groupIds = []) => {
  const res = await http.delete(BASE_URL, { data: groupIds });
  return res.data;
}, 'DELETE', `${BASE_URL}`);

// 사용자 그룹 멤버 업데이트
export const updateUserGroupMembers = withPerm(async (groupId, userIds = []) => {
  const res = await http.put(`${BASE_URL}/${groupId}/users`, userIds, { headers: { 'Content-Type': 'application/json' } });
  return res.data;
}, 'PUT', `${BASE_URL}/{groupId}/users`);

// 메뉴그룹 멤버 업데이트
export const updateMenuGroupMembers = withPerm(async (groupId, menuIds = []) => {
  const res = await http.put(`${BASE_URL}/${groupId}/menus`, menuIds, { headers: { 'Content-Type': 'application/json' } });
  return res.data;
}, 'PUT', `${BASE_URL}/{groupId}/menus`);

// API그룹 멤버 업데이트 추가
export const updateApiGroupMembers = withPerm(async (groupId, apiIds = []) => {
  const res = await http.put(`${BASE_URL}/${groupId}/apis`, apiIds, { headers: { 'Content-Type': 'application/json' } });
  return res.data;
}, 'PUT', `${BASE_URL}/{groupId}/apis`);

export const GROUP_TYPE_OPTIONS = [
  { value: 'USER_GROUP', label: '사용자그룹' },
  { value: 'MENU_GROUP', label: '메뉴그룹' },
  { value: 'API_GROUP', label: 'API그룹' }
];
